import {createSlice,createAsyncThunk} from "@reduxjs/toolkit";

const jobSlice = createSlice({
    name:'job', 
    initialState:{ 
        loading: false,
        jobs :[],
        job:{}
    },
    reducers:{
        add_job:(state,action)=>{
            state.job = action.payload
        },
        add_jobs:(state,action)=>{
            state.jobs = action.payload
        },
        delete_jobs:(state)=>{
            state.jobs = []
        },
        delete_job:(state)=>{
            state.job = {}
        }
    }
})

export const {add_job,add_jobs,delete_job,delete_jobs} = jobSlice.actions;
export default jobSlice.reducer;